import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { McdFinTrendChart } from './McdFinTrendChart';

export const PaidTrendsCard = ({ formValues }) => {

  const [isChart, setIsChart] = useNavStateSync('paidTrendIsChart', true);

  const paidTrendButtons = (
    <ToggleButtonGroup exclusive size="small" value={isChart} sx={{ width: 'fit-content' }} onChange={(event, value) => { setIsChart(value) }}>
      <ToggleButton value={true} aria-label="bold">
        Chart
      </ToggleButton>
      <ToggleButton value={false} aria-label="bold">
        Table
      </ToggleButton>
    </ToggleButtonGroup>
  );
  
  return (
    <DashboardCard title="Quarter Over Quarter Paid Trends" buttons={paidTrendButtons} >
      <McdFinTrendChart formValues={formValues} isPaid={true} isChart={isChart} />
    </DashboardCard>
  )
}